import React from 'react';
import { CONFIG_OPTIONS, ROOM_NAME_MAX } from '../config';

function RoomForm({ roomName, onRoomNameChange, params, onToggleParam, onSubmit }) {
  const disabled = roomName.trim().length === 0;

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !disabled) {
      onSubmit();
    }
  };

  return (
    <>
      <label htmlFor="roomInput" className="field__label">Название встречи</label>
      <input
        id="roomInput"
        className="field__input"
        type="text"
        autoFocus
        placeholder="Введите название комнаты"
        value={roomName}
        maxLength={ROOM_NAME_MAX}
        onChange={(e) => onRoomNameChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />

      <fieldset className="options">
        <legend className="options__legend">Параметры конференции</legend>
        <div className="options__grid">
          {CONFIG_OPTIONS.map(({ key, label }) => (
            <div key={key} className="options__row">
              <label className="options__label">
                <input
                  type="checkbox"
                  className="options__checkbox"
                  checked={Boolean(params[key])}
                  onChange={() => onToggleParam(key)}
                />
                {label}
              </label>
            </div>
          ))}
        </div>
      </fieldset>

      <button
        type="button"
        className="btn btn--primary"
        disabled={disabled}
        onClick={onSubmit}
      >
        Создать и скопировать ссылку
      </button>
    </>
  );
}

export default RoomForm;
